<template>
  <div class="pages">
    <Header :data="headerData" :popObjMouth="popObjMouth" :popObjGoods="popObjGoods"></Header>
    <div class="tabs">
      <div class="tab">
        <div @click="changeDateType(1)" :class="[{'tab-item-active':tabActiveType === 1}]" class="tab-item">日</div>
        <div @click="changeDateType(2)" :class="[{'tab-item-active':tabActiveType === 2}]" class="tab-item">月</div>
        <img v-if="activeType && !selectArea.isSelectArea && userInfo.level < 2" @click="changeType" class="tabs-img" src="../../assets/app/line-chart.png" alt="">
        <img v-if="!activeType && !selectArea.isSelectArea && userInfo.level < 2" @click="changeType" class="tabs-img tabs-img-rank" src="../../assets/app/rank.png" alt="">
      </div>
    </div>
    <div>
      <div v-if="activeType && !selectArea.isSelectArea && userInfo.level < 2">
        <div class="rankings">
          <img class="rankings-img" src="../../assets/app/cup.png" alt="">
          <font>{{headerData.rankTitle}}</font>
        </div>
        <RankList :list="initList" :type="tabActiveType" @change="getDataByRank"></RankList>
      </div>
      <LineChart v-if="!activeType" :thanTitle="headerData.thanTitle" :thanTitle2="headerData.thanTitle2" :xData="xData" :yDataSame="yDataSame" :yDataRing="yDataRing"></LineChart>
      <Tables v-show="showTables" :type="tabActiveType" :xList="xDataList" :yList="dataList" :xDataXList="xDataXList"></Tables>
    </div>
  </div>
</template>

<script>
import DOMAIN from "libs/domain.js";
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import Header from "com/app/add/header.vue";
import RankList from "com/app/add/rankList.vue";
import Tables from "com/app/add/tables.vue";
import LineChart from "com/app/add/lineChart.vue";
import addMixin from "mixins/add/add.js";
import { formatDateTimeReg } from "libs/common/common";
export default {
  components: {
    Header,
    RankList,
    Tables,
    LineChart
  },
  mixins: [addMixin],
  data () {
    return {
      isFirstEnter: false, // 是否第一次进入，默认false
      isReadyToGetData: false, // 根据url是否完善了，才可以请求接口
      showTables: false, // 是否显示表格，默认false
      headerData: {
        //头部的数据
        unit: "",
        thanTitle: "比上月",
        thanTitle2: "比上年",
        bestTitle: "今月最优",
        worstTitle: "今月最差",
        rankTitle: "排行",
        bestAreaName: "",
        worstAreaName: "",
        bestData: 0,
        worstData: 0,
        family: "0", //总数
        lastMonth: "", //环比值
        lastYear: "" //同比值
      },
      popObjMouth: {
        //口径的数据
        title: "",
        ind_unit: "元",
        remark: "",
        top: "0.7rem",
        right: "-0.2rem",
        topRight: "0.15rem",
        visable: false,
        type: 1
      },
      popObjGoods: {
        //最优最差的数据
        title: "",
        ind_unit: "元",
        remark: "",
        top: "1.6rem",
        right: "1.4rem",
        topRight: "1.56rem",
        visable: false,
        type: 2
      },
      initList: [], //排名的数据
      xDataList: [], //表头数据（字段与名称）
      xDataXList: [], //表头字段的数据
      dataList: [], //表格数据与拆线y坐标的数据
      tabActiveType: '', //日月 tab切换的类型
      activeType: false, // 排行榜与表格切换的类型
      xData: [], //X坐标数据
      yDataSame: [], //同比数据
      yDataRing: [], //环比数据
      type: this.$route.query.type ? String(this.$route.query.type).toUpperCase() : "", //指标类型
      collectMonthType: '', //收藏的 月 指标id 类型
      collectDayType: '', //收藏的 日 指标id 类型
      collectMonthName: '', //收藏的 月 指标id 名称
      collectDayName: '', //收藏的 日 指标id 名称
      typeAllList: [], //所有返回的请求指标类型与请求接口标志 像191
      dayUrl: DOMAIN + "t/mobile/data/", //日的请求链接
      monthUrl: DOMAIN + "t/mobile/data/", //月的请求链接
      disabledDay: true, //是否禁止切换日
      disabledMonth: true, //是否禁止切换月
      areaId: "", //请求地区数据的id
      rate: {
        //用于 判断 同比 环比
        sameRate: "", // 同比的key值
        ringRate: "" // 环比的key值
      },
      backDateTimes: 1 //往前回溯的天数
    };
  },
  methods: {
    // 清空初始数据
    clearInitData () {
      this.initList = [];
      this.xData = [];
      this.yDataSame = [];
      this.yDataRing = [];
      this.xDataList = []; //表头数据（字段与名称）
      this.xDataXList = []; //表头字段的数据
      this.dataList = [];
    },
    // 根据日月类型来获取时间 type ： 1 日 ， 2 月
    getTime (type) {
      if (type == 1) {
        let date = formatDateTimeReg(new Date(), "YYYY-MM-DD mm:ss").slice(0, 8);
        return date;
      } else {
        let date = formatDateTimeReg(new Date(), "YYYY-MM-DD mm:ss").slice(0, 6);
        return date;
      }
    },
    // 根据日月类型来获取数据 type ： 1 日 ， 2 月
    getData (type) {
      if (type == 1) {
        let date = formatDateTimeReg(new Date(), "YYYY-MM-DD mm:ss").slice(0, 8);
        this.getDayData(date, this.areaId);
      } else {
        let date = formatDateTimeReg(new Date(), "YYYY-MM-DD mm:ss").slice(0, 6);
        this.getMonthData(date, this.areaId);
      }
    },
    // 获取 日 的数据
    getDayData (date, id) {
      this.clearInitData();
      this.$http
        .post(this.dayUrl, {
          area_id: id,
          // "date": 20180604,
          date: Number(date)
        })
        .then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            // 头部比值总数等数据
            if (res.data.data.d_data.length) {
              this.backDateTimes = 1;
              for (let i in res.data.data.d_data[0]) {
                // 根据 hb tb 来判断是同比还是环比值
                if (i.includes("_hb")) {
                  this.rate.sameRate = i;
                  this.headerData.lastMonth = res.data.data.d_data[0][i];
                } else if (i.includes("_tb")) {
                  this.rate.ringRate = i;
                  this.headerData.lastYear = res.data.data.d_data[0][i];
                } else {
                  this.headerData.family = res.data.data.d_data[0][i];
                }
              }
              // 口径数据
              if (res.data.data.d_kj.length) {
                this.popObjMouth.ind_unit = res.data.data.d_kj[0].ind_unit;
                this.popObjMouth.remark = res.data.data.d_kj[0].remark;
                this.popObjMouth.title = res.data.data.d_kj[0].ind_name;

                document.title = res.data.data.d_kj[0].ind_name;
                this.setTitle({
                  title: res.data.data.d_kj[0].ind_name
                });

                this.popObjGoods.remark = res.data.data.d_kj[0].pm_name;
                this.headerData.unit = res.data.data.d_kj[0].ind_unit;
                this.headerData.rankTitle = res.data.data.d_kj[0].pm_name;
              } else {
                this.popObjMouth.ind_unit = "";
                this.popObjMouth.remark = "";
                this.popObjMouth.title = "";
              }
              // 排名
              if (res.data.data.d_pm.length) {
                let len = res.data.data.d_pm.length;
                this.initList = res.data.data.d_pm;
                this.headerData.bestAreaName = this.initList[0].area_name;
                this.headerData.worstAreaName = this.initList[len - 1].area_name;
                this.headerData.bestData = this.vdBestWorstValue(this.initList[0], "tb", "_pm");
                this.headerData.worstData = this.vdBestWorstValue(this.initList[len - 1], "tb", "_pm");
              } else {
                this.headerData.bestAreaName = "";
                this.headerData.worstAreaName = "";
                this.headerData.bestData = 0;
                this.headerData.worstData = 0;
              }
              // 表头
              if (res.data.data.d_bt.length) {
                this.xDataList = res.data.data.d_bt;
                for (let i = 0; i < res.data.data.d_bt.length; i++) {
                  this.xDataXList.push(res.data.data.d_bt[i].zd_name);
                }
              }
              // 拆线也是表格数据
              if (res.data.data.d_zx.length) {
                // 因为当天的没有数据，后台不做回溯，只有传的不是当天的后台程序才做回溯，
                // 所以前端取最新的一条数据的日期来展示
                let date = String(res.data.data.d_zx[0].statis_date).split("");
                let [year, month, day] = [date[0] + date[1] + date[2] + date[3], date[4] + date[5], date[6] + date[7]];
                let selectDate = year + "-" + month + "-" + day;
                this.$store.commit("SAVE_SHOW_SELECT_DATE_VALUE", {
                  showSelectDateValue: selectDate
                });

                this.dataList = res.data.data.d_zx.reverse();
                this.dataList.forEach((i, index) => {
                  this.xData.push(i.statis_date.toString().slice(4, 8));
                  this.yDataSame.push(this.vdRateValue(i, this.rate.sameRate));
                  this.yDataRing.push(this.vdRateValue(i, this.rate.ringRate));
                });
              }
              this.showTables = true;
            } else {
              // 没有数据要向前回溯 1 日
              let activeDate = this.activeDate;
              let preDate = new Date(
                activeDate.getTime() - 24 * 60 * 60 * 1000 * 1
              );
              // 因为 preDate 已经是时间戳,所以要转换为 时间对象
              var newDate = new Date(preDate);
              this.$store.commit("SAVE_ACTIVE_DATE", {
                activeDate: newDate
              });
            }
          } else {
            Toast(res.data.message);
          }
        })
        .catch(error => {
          Toast("获取当前日数据失败");
          Indicator.close();
          console.log(error);
        });
    },
    // 获取 月 的数据
    getMonthData (date, id) {
      this.clearInitData();
      this.$http
        .post(this.monthUrl, {
          // "area_id": 0,
          area_id: id,
          // "date": 20180604,
          date: Number(date)
        })
        .then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            // 头部比值总数等的数据
            if (res.data.data.m_data.length) {
              this.backDateTimes = 1;
              for (let i in res.data.data.m_data[0]) {
                // 根据 hb tb 来判断是同比还是环比值
                if (i.includes("_hb")) {
                  this.rate.sameRate = i;
                  this.headerData.lastMonth = res.data.data.m_data[0][i]; //新增环比值
                } else if (i.includes("_tb")) {
                  this.rate.ringRate = i;
                  this.headerData.lastYear = res.data.data.m_data[0][i]; //新增同比值
                } else {
                  this.headerData.family = res.data.data.m_data[0][i]; //新增总数
                }
              }
              // 口径
              if (res.data.data.m_kj.length) {
                this.popObjMouth.ind_unit = res.data.data.m_kj[0].ind_unit;
                this.popObjMouth.remark = res.data.data.m_kj[0].remark;
                this.popObjMouth.title = res.data.data.m_kj[0].ind_name;

                document.title = res.data.data.m_kj[0].ind_name;
                this.setTitle({
                  title: res.data.data.m_kj[0].ind_name
                });

                this.popObjGoods.remark = res.data.data.m_kj[0].pm_name;
                this.headerData.unit = res.data.data.m_kj[0].ind_unit;
                this.headerData.rankTitle = res.data.data.m_kj[0].pm_name;
                // console.log('document.title', document.title)
              } else {
                this.popObjMouth.ind_unit = "";
                this.popObjMouth.remark = "";
                this.popObjMouth.title = "";
              }
              // 排名
              if (res.data.data.m_pm.length) {
                this.initList = res.data.data.m_pm;
                let len = res.data.data.m_pm.length;
                this.initList = res.data.data.m_pm;
                this.headerData.bestAreaName = this.initList[0].area_name;
                this.headerData.worstAreaName = this.initList[len - 1].area_name;
                this.headerData.bestData = this.vdBestWorstValue(this.initList[0], "hb", "_pm");
                this.headerData.worstData = this.vdBestWorstValue(this.initList[len - 1], "hb", "_pm");
              } else {
                this.headerData.bestAreaName = "";
                this.headerData.worstAreaName = "";
                this.headerData.bestData = 0;
                this.headerData.worstData = 0;
              }
              // 表格的表头数据
              if (res.data.data.m_bt.length) {
                this.xDataList = res.data.data.m_bt;
                for (let i = 0; i < res.data.data.m_bt.length; i++) {
                  this.xDataXList.push(res.data.data.m_bt[i].zd_name);
                }
              }
              // 拆线数据
              if (res.data.data.m_zx.length) {
                // 因为当天的没有数据，后台不做回溯，只有传的不是当天的后台程序才做回溯，
                // 所以前端取最新的一条数据的日期来展示
                let date = String(res.data.data.m_zx[0].statis_date).split("");
                let [year, month] = [date[0] + date[1] + date[2] + date[3], date[4] + date[5]];
                let selectDate = year + "-" + month;
                this.$store.commit("SAVE_SHOW_SELECT_DATE_VALUE", {
                  showSelectDateValue: selectDate
                });

                this.dataList = res.data.data.m_zx.reverse();
                this.dataList.forEach(i => {
                  this.xData.push(i.statis_date.toString().slice(4, 8));
                  this.yDataSame.push(this.vdRateValue(i, this.rate.sameRate));
                  this.yDataRing.push(this.vdRateValue(i, this.rate.ringRate));
                });
              }
              this.showTables = true;
            } else {
              // 没有数据要向前回溯 1 个月
              let activeDate = this.activeDate;
              let preDate = activeDate.setMonth(activeDate.getMonth() - 1);
              // 因为 preDate 已经是时间戳,所以要转换为 时间对象
              let newDate = new Date(preDate);
              this.$store.commit("SAVE_ACTIVE_DATE", {
                activeDate: newDate
              });
            }
          }
        })
        .catch(error => {
          Toast("获取当前月数据失败");
          Indicator.close();
          console.log(error);
        });
    },
    // 获取所有指标类型与 id 的数据
    getDataTypeAll () {
      Indicator.open();
      let date = formatDateTimeReg(new Date(), "YYYY-MM-DD mm:ss").slice(0, 8);
      this.$http
        .post(this.$urls.data184, {
          area_id: this.areaId,
          date: Number(date)
        })
        .then(res => {
          // Indicator.close()
          if (res.data.code === 200) {
            this.typeAllList = res.data.data.skpi;
            this.$store.commit("SAVE_TYPE_ALL_LIST", {
              typeAllList: this.typeAllList
            });
            // 根据链接的url的type指标来指定请求的日月的url
            for (let i = 0; i < this.typeAllList.length; i++) {
              // 月指标
              if (this.typeAllList[i].ind_id.toUpperCase() === this.type) {
                this.tabActiveType = 2
                this.collectDayType = this.typeAllList[i].ind_id_d.toUpperCase()
                this.collectMonthType = this.typeAllList[i].ind_id.toUpperCase()
                this.collectDayName = this.typeAllList[i].ind_name_d
                this.collectMonthName = this.typeAllList[i].ind_name
                this.dayUrl = this.dayUrl + this.typeAllList[i].d_jk;
                this.monthUrl = this.monthUrl + this.typeAllList[i].m_jk;
                if (this.typeAllList[i].d_jk == 0) {
                  this.disabledDay = false;
                }
                if (this.typeAllList[i].m_jk == 0) {
                  this.disabledMonth = false;
                }
                this.$store.commit("SAVE_COLLECT_DATA", {
                  collectDate: {
                    collectType: this.collectMonthType,
                    collectName: this.collectMonthName
                  }
                });
                break;
              }
              // 日指标
              if (this.typeAllList[i].ind_id_d.toUpperCase() === this.type) {
                this.tabActiveType = 1
                this.collectDayType = this.typeAllList[i].ind_id_d.toUpperCase()
                this.collectMonthType = this.typeAllList[i].ind_id.toUpperCase()
                this.collectDayName = this.typeAllList[i].ind_name_d
                this.collectMonthName = this.typeAllList[i].ind_name
                this.dayUrl = this.dayUrl + this.typeAllList[i].d_jk;
                this.monthUrl = this.monthUrl + this.typeAllList[i].m_jk;
                if (this.typeAllList[i].d_jk == 0) {
                  this.disabledDay = false;
                }
                if (this.typeAllList[i].m_jk == 0) {
                  this.disabledMonth = false;
                }
                this.$store.commit("SAVE_COLLECT_DATA", {
                  collectDate: {
                    collectType: this.collectDayType,
                    collectName: this.collectDayName
                  }
                });
                break;
              }
            }
            this.isReadyToGetData = true;
            this.$store.commit("SAVE_TAB_ACTIVE_TYPE", {
              tabActiveType: this.tabActiveType
            });

            // 默认获取 月 的数据
            this.$store.commit("SAVE_ACTIVE_DATE", {
              activeDate: new Date()
            });
          }
        })
        .catch(error => {
          Indicator.close();
          console.log(error);
        });
    },
    // 最优最差值验证 item 每一项是对象，notFlag 不包括的标志是字符串
    vdBestWorstValue (item, flag, notFlag) {
      let value = "";
      for (let i in item) {
        if (i != "area_name" && i != "area_id" && !i.includes(notFlag)) {
          value = item[i];
        }
      }
      return value;
    },
    // 最优最差值验证 item 每一项是对象，flag 包括的标志 是字符串
    vdRateValue (item, flag) {
      let value = "";
      for (let i in item) {
        if (i == flag) {
          value = item[i];
        }
      }
      return value;
    },
    // 根据点击的排名来下钻，也是选择地区
    getDataByRank (item) {
      let obj = {
        isSelectArea: this.selectArea.isSelectArea,
        selectCityId: this.selectArea.selectCityId,
        selectAreaId: this.selectArea.selectAreaId,
        selectAreaName: item.area_name
      };
      console.log('this.selectArea', this.selectArea)
      // 点击排行时选择了区
      if (this.selectArea.selectCityId && this.selectArea.selectAreaId) {
        obj.selectCityId = item.area_id;
        obj.selectAreaId = item.area_id;
        obj.isSelectArea = true;
      }
      else if (this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
        // 点击排行时选择了区
        obj.selectCityId = item.area_id;
        obj.selectAreaId = item.area_id;
        obj.isSelectArea = true;
      } else if (this.userInfo.level === 0 && !this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
        // 点击排行时选择了市
        obj.selectCityId = item.area_id;
        obj.selectAreaId = "";
        obj.isSelectArea = false;
      } else if (this.userInfo.level === 1 && !this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
        // 点击排行时选择了区
        obj.selectCityId = '';
        obj.selectAreaId = item.area_id;
        obj.isSelectArea = true;
      }
      this.$store.commit("SAVE_SELECT_AREA", {
        selectArea: obj
      });
      console.log('this.selectArea22', this.selectArea)
    },
    // 日月类型的切换
    changeDateType (type) {
      if (type === 1 && this.disabledDay) {
        this.tabActiveType = type;
        this.headerData.bestTitle = "今日最优";
        this.headerData.worstTitle = "今日最差";
        this.headerData.thanTitle = "比上日";
        this.headerData.thanTitle2 = "比上月";
        this.$store.commit("SAVE_COLLECT_DATA", {
          collectDate: {
            collectType: this.collectDayType,
            collectName: this.collectDayName
          }
        });
        // 切换日月 默认最新的日期
        this.$store.commit("SAVE_ACTIVE_DATE", {
          activeDate: new Date()
        });
        this.$store.commit("SAVE_TAB_ACTIVE_TYPE", {
          tabActiveType: this.tabActiveType
        });
        Indicator.open();
      } else if (type === 1 && !this.disabledDay) {
        Toast("该指标下只有月相关数据");
      } else if (type === 2 && this.disabledMonth) {
        this.tabActiveType = type;
        this.headerData.bestTitle = "今月最优";
        this.headerData.worstTitle = "今月最差";
        this.headerData.thanTitle = "比上月";
        this.headerData.thanTitle2 = "比上年";
        this.$store.commit("SAVE_COLLECT_DATA", {
          collectDate: {
            collectType: this.collectMonthType,
            collectName: this.collectMonthName
          }
        });
        // 切换日月 默认最新的日期
        this.$store.commit("SAVE_ACTIVE_DATE", {
          activeDate: new Date()
        });
        this.$store.commit("SAVE_TAB_ACTIVE_TYPE", {
          tabActiveType: this.tabActiveType
        });
        Indicator.open();
      } else if (type === 2 && !this.disabledMonth) {
        Toast("该指标下只有日相关数据");
      }

    },
    // 拆线与排行榜的切换
    changeType () {
      this.activeType = !this.activeType;
    },
    // 选择的日期改变的时候
    getDates () {
      let date = formatDateTimeReg(this.activeDate, "YYYY-MM-DD mm:ss");
      if (this.tabActiveType == 1) {
        date = date.slice(0, 8);
        this.getDayData(date, this.areaId);
      } else {
        date = date.slice(0, 6);
        this.getMonthData(date, this.areaId);
      }
    },
    // 根据地区修改来变更数据
    getDataBySelectArea () {
      // 等级 用于区分能下钻几层 ，0 是省，1 是市，2 是县或者分公司
      // 选择到省
      if (this.userInfo.level == 0 && !this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
        this.areaId = 0;
        Indicator.open();
        this.getDates();
      } else if (this.userInfo.level == 0 && this.selectArea.selectCityId && this.selectArea.selectAreaId) {
        // 选择到区
        this.areaId = this.selectArea.selectAreaId;
        Indicator.open();
        this.getDates();
        this.activeType = false;
      } else if (this.userInfo.level == 0 && this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
        // 选择到市
        this.areaId = this.selectArea.selectCityId;
        Indicator.open();
        this.getDates();
      } else if (this.userInfo.level == 1 && this.selectArea.selectAreaId) {
        // 选择到区
        this.areaId = this.selectArea.selectAreaId;
        Indicator.open();
        this.getDates();
        this.activeType = false;
      } else if (this.userInfo.level == 1 && !this.selectArea.selectAreaId && this.selectArea.selectCityId) {
        // 选择到市
        this.areaId = this.selectArea.selectCityId;
        Indicator.open();
        this.getDates();
        this.activeType = false;
      }
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      this.areaId = this.$store.state.userInfo.aid;
      return this.$store.state.userInfo;
    },
    // 当前请求的日期
    activeDate () {
      return this.$store.state.add.activeDate;
    },
    // 当前选择的地区
    selectArea () {
      return this.$store.state.add.selectArea;
    }
  },
  watch: {
    userInfo () {
      let obj = {
        isSelectArea: this.selectArea.isSelectArea,
        selectCityId: this.selectArea.selectCityId,
        selectAreaId: this.selectArea.selectAreaId,
        selectAreaName: this.userInfo.area
      };
      this.$store.commit("SAVE_SELECT_AREA", {
        selectArea: obj
      });
      this.getDataTypeAll();
    },
    activeDate () {
      this.getDates();
    },
    selectArea () {
      if (this.isReadyToGetData) {
        this.getDataBySelectArea();
      }
    }
  },
  mounted () {

  }
};
</script>

<style lang="less">
@main-color: #43484d;
@main-color-2: #86939e;
@main-color-green: #269513;
@main-color-yellow: #fc9d2e;
.font-family-fn(@family) {
  font-family: @family;
}

.button {
  font-size: 0.5rem;
}

::-webkit-scrollbar {
  display: none; //隐藏滚动条，保留鼠标滚动效果
}

.pages {
  -webkit-overflow-scrolling: touch; // ios滑动顺畅
  padding-bottom: 0.7rem;
}

.tabs {
  position: relative;
  height: 0.78rem;
  padding-top: 0.22rem;
  padding-left: 2.14rem;
  background-color: #f3f4f6;
  .tab {
    width: 3.2rem;
    font-size: 0.32rem;
    display: flex;
    border: 0.02rem solid #e4e4e4;
    .tab-item {
      text-align: center;
      flex: 1;
      color: #86939e;
    }
    .tab-item-active {
      background-color: #0384df;
      color: #fefefe;
    }
  }
  .tabs-img {
    width: 0.45rem;
    position: absolute;
    right: 0.51rem;
    top: 0.22rem;
  }
  .tabs-img-rank {
    width: 0.37rem;
    position: absolute;
    right: 0.51rem;
    top: 0.22rem;
  }
}

.rankings {
  .font-family-fn("PingFang-SC-Heavy");
  position: relative;
  font-size: 0.32rem;
  height: 0.75rem;
  line-height: 0.75rem;
  color: #fefefe;
  padding-left: 2.2rem;
  background-color: #69b0ec;
  .rankings-img {
    position: absolute;
    left: 1rem;
    top: 0.1rem;
    width: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/add.vue